import { Popper, PopperProps, TextField } from '@mui/material'
import Autocomplete from '@mui/material/Autocomplete'
import styled from 'styled-components'
import Message from '../Message/Message'

const StyledTextField = styled(TextField)`
  div.MuiInputBase-root.MuiOutlinedInput-root {
    padding-right: 0 !important;

    input {
      padding-left: 15px !important;
    }

    .MuiAutocomplete-input {
      padding: 6.5px 4px 6.5px 6px;
    }

    svg.MuiSvgIcon-root {
      color: rgba(0, 0, 0, 0.54);
    }

    .MuiAutocomplete-endAdornment {
      right: 0px;
    }

    &.Mui-focused {
      input {
        padding: 7px 15px 6px 15px !important;
      }
    }
  }

  fieldset {
    border: none;
  }
`

interface Option {
  value: string
  label: string
}

interface Props {
  options: Option[]
  value: string
  name: string
  label: string
  setValue: (val: string) => void
  error?: string
  minWidth?: number
  disabled?: boolean
}

const AutoCompleteSelect = ({
  value,
  error,
  options,
  name,
  label,
  setValue,
  minWidth = 268,
  disabled = false,
}: Props) => {
  const MyPopper = function (props: PopperProps) {
    return (
      <Popper
        {...props}
        style={{ transform: 'translateY(40px) !important', minWidth }}
        placement="bottom"
      />
    )
  }

  const selectedValue = options.find((x: Option) => x.value === value)

  return (
    <div className={error ? 'error' : ''}>
      <Autocomplete
        value={selectedValue}
        options={options}
        sx={{
          '& .MuiInputBase-root': { p: 0 },
          '& .Mui-focused': { p: 0 },
        }}
        onChange={(event: any, newValue: any) => {
          if (newValue && newValue.value) {
            setValue(newValue.value)
          } else {
            setValue('')
          }
        }}
        renderInput={(params) => (
          <>
            <label htmlFor={name}>{label}</label>
            <StyledTextField variant="outlined" name="forgetMe" {...params} />
          </>
        )}
        PopperComponent={MyPopper}
        disabled={disabled}
      />
      {error !== '' && (
        <Message style={{ marginTop: 0 }} variant="danger">
          {error}
        </Message>
      )}
    </div>
  )
}

export default AutoCompleteSelect
